<div class="flex w-full justify-between">
    <h2 class="text-xl font-bold">{{ 'GL.PAYMENT_TYPE.TITLE' | translate }}</h2>
    <button class="btn btn-primary mb-3 font-bold" (click)="openAddPopup()">
        {{ 'GL.PAYMENT_TYPE.ADD' | translate }}
    </button>
</div>

<app-table [columns]="columns" [data]="data" [actions]="actions"></app-table>

<app-popup [(show)]="showPopup" [title]="popupTitle" [fields]="popupFields"
    [onSave]="handleSave.bind(this)">
</app-popup>